import { SplitMode } from "../types";

export const SplitModeNames: Record<SplitMode, string> = {
    [SplitMode.qr]: "QR-Code",
    [SplitMode.every]: "jede Seite",
    [SplitMode.second]: "jede zweite Seite",
    [SplitMode.manual]: "manuelle Bearbeitung",
    [SplitMode.put]: "Verbinden",
};
